import { Component,
    Output,
    Input,
    EventEmitter,
    ElementRef,
    Renderer,
    OnChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../../common/global-variables';
import { TreeComponent, TreeService, TreeNode } from '../../../../../../../common/tree';
import { Service } from '../out-of-place-restore.service';
import { Subscription } from 'rxjs/Rx';
import { RestoreTreeConstants } from '../out-of-place-restore-constants';

@Component({
    selector: 'step-2',
    providers: [ Service, TreeService ],
    styles: [
        require('./step-2.scss')
    ],
    encapsulation: ViewEncapsulation.None,
    template: require('./step-2.html')
})

export class VmComputeResourceTree implements OnChanges {
    @Input() vcId: String;
    @Input() datacenterId: String;
    @Output() onComputeResourceSelection = new EventEmitter();

    private url: String = "/hybridity/api/vc/query?";
    private subscription: Subscription;

    private options = {
        idField: 'entity_id',
        displayField: 'name',
        getChildren: this.getChildren.bind(this),
        getIconClass: this.getIconClass.bind(this),
        isExpandedField: 'expanded',
        hasContextMenu: true,
        contextMenuActionMapping: {},
        menuLinksMapping: {},
        typeField: 'entityType',
        leafTypes: ['host']
    };

    private nodes = [];

    private output = {
        entityType: '',
        entity_id: '',
        name: ''
    }

    @ViewChild(TreeComponent)
    private tree: TreeComponent;

    constructor(public outOfPlaceRestoreService: Service, private elementRef: ElementRef,
                private renderer: Renderer, private translate: TranslateService,
                private treeService: TreeService) {
        translate.use(GlobalVariables.LOCALE);
    }

    getElementReference() {
        return this.elementRef;
    }

    ngOnChanges(changes) {
        if ((changes && changes.vcId && changes.vcId.currentValue && this.datacenterId)
                            || (changes.datacenterId && changes.datacenterId.currentValue && this.vcId)) {
            this.subscription =
            this.outOfPlaceRestoreService.getTreeNodes(this.getUrl(this.datacenterId, this.vcId, 'datacenter')).subscribe((nodes: any) => {
                    this.nodes = nodes;
                },
                error => {},
                () => {}
            );
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    getChildren(node) {
        let parentId: String = node.data.entity_id;
        let entityType: String = node.data.entityType;

        return this.outOfPlaceRestoreService.getChildNodes(this.getUrl(parentId, this.vcId, entityType));
    }

    getUrl(parentId, vcId, entityType) {
        return this.url + RestoreTreeConstants.getComputeViewChildrenQueryParameters(entityType)
                    + '&filter=parentId==' + parentId + ';vcenterId==' + vcId;
    }

    getIconClass(node) {
    }

    onNodeSelection = (event) => {
        if (event && event.node && event.node.data && event.node.data.entity_id
                && event.node.data.entityType && event.node.data.entityType !== 'folder') {
            this.output.entityType = event.node.data.entityType;
            this.output.entity_id = event.node.data.entity_id;
            this.output.name = event.node.data.name;
            this.onComputeResourceSelection.emit(this.output);
        } else {
            this.onComputeResourceSelection.emit();
        }
    };

    onEvent = ($event) => {
    };

    onTreeInit = ($event) => {
        console.log('Tree Initialised');
    };

    onFocus = ($event) => {
    };
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/out-of-place-restore/step-2/step-2.component.ts